import type { CustomizableCookie } from './types'

// These values are set in user's cookie storage and used by other stacks.
// Do not update them.
export const COOKIES: Record<CustomizableCookie, string> = {
  advertising: 'BM_Advertising',
  analytics: 'BM_Analytics',
  userExperience: 'BM_User_Experience',
}

export const GDPR_COOKIE_DURATION_IN_MONTHS = 6

export const ESSENTIAL_PURPOSE_ID = 'forthebr-qmYfF3Ry'
export const ESSENTIAL_ITEMS_NAMES = [
  'ab.optOut',
  '_cfuvid',
  '__cf_bm',
  'country_switch_clicked_at',
  'didomi_token',
  'didomi_dcs',
  'euconsent-v2',
  '__MCP_DEBUG_DATA__',
  'sessionid',
  'session_id',
  'showCatchupModal',
  'sourcingOpportunities_lastSearch',
  'tradein_au_accepted_offer',
  'utm_source',
  'visitor_id',
]
const ESSENTIAL_ITEMS_PREFIX = [
  'algolia',
  'backmarket-seller',
  'BM_',
  'bo_merchant',
  'bo_seller',
  'buyback_offer',
  'cf_',
  'cf.',
  'CHECKOUT_PRICE_UPDATES_',
  'com.grafana',
  'csrf',
  'didomi_token_',
  'favorites_pending-action',
  'oauth',
  'ory_kratos_session',
  'popup_state_',
]

export const ESSENTIAL_ITEMS_REGEX = new RegExp(
  `^(${ESSENTIAL_ITEMS_PREFIX.map((item) => item.replaceAll('.', '\\.')).join('|')})`,
  'i',
)
